/**
 * Short description for file
 *
 * Author: H.R. Shadhin <dev@hrshadhin.me>
 *
 * LICENSE: AGP 3.0
 *
 * DATE: 3/10/19
 * TIME: 8:54 PM
 */

import Generic from "./Generic";

export default class Payroll {
    static salaryTemplateInit() {
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();
    }
    static salaryInit(){
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();

        $('.btnSalaryDistributionView').click(function () {
            let pk = $(this).attr('data-pk');
            let getUrl = window.salaryListUrl+"?salary_id="+pk;
            $('#distributionListTable tbody').empty();
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    // console.log(response);
                    if(response.data.length){
                        response.data.forEach(function(distribution, index) {
                            let trRow = '<tr>\n' +
                                '<td>'+(index + 1)+'</td>\n' +
                                ' <td>'+distribution.name+'('+distribution.type+')</td>\n' +
                                '<td>'+distribution.amount+'</td>\n' +
                                '<td>\n'+
                                '</tr>';
                            $('#distributionListTable tbody').append(trRow);
                        });

                        $('#modalSalaryDistribution').modal('show');
                    }
                    else{
                        toastr.error('Data not found!');
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });
    }

    static paymentInit(){
        Generic.initCommonPageJS();
        Generic.initDeleteDialog();
        $('select[name="employee_id"]').on('change', function(){
            $('#salaryInfoDiv').hide();
            $('input[name="pay_month"]').val('');
        });
        $('input[name="pay_month"]').on('dp.change', function () {
            let employee_id = $('select[name="employee_id"]').val();
            let month_year = $(this).val();
            if(!employee_id || !month_year.length){
                return false;
            }
            let getUrl = window.getSalaryStatusAjaxUrl.slice(0,-3)+employee_id+'/'+encodeURIComponent(month_year);
            Generic.loaderStart();
            axios.get(getUrl)
                .then((response) => {
                    if(response.data.success){
                        $('#salaryAmount').text(response.data.salary);
                        $('#withDrawAmount').text(response.data.withdraw);
                        $('#deductionAmount').text(response.data.deduction);
                        $('#balanceAmount').text(response.data.balance);
                        $('input[name="amount"]').attr('max', response.data.balance.replace(',',''));
                        $('#salaryInfoDiv').show();
                    }
                    else {
                        toastr.error(response.data.message);
                        $('input[name="pay_month"]').val('').trigger('dp.change');
                        $('#salaryInfoDiv').hide();
                    }
                    Generic.loaderStop();
                }).catch((error) => {
                let status = error.response.statusText;
                toastr.error(status);
                Generic.loaderStop();
            });
        });

        $('.documentUp').change(function(){
            var input = this;
            var url = $(this).val();
            var ext = url.substring(url.lastIndexOf('.') + 1).toLowerCase();
            if (input.files && input.files[0]&& (ext == "png" || ext == "jpeg" || ext == "jpg"
                || ext == "txt" || ext == "text" || ext == "doc" || ext == "docx" || ext == "pdf" || ext == "odt"))
            {
                //validate size
                var sizeImg =input.files[0].size/1024;
                if (sizeImg>1024) {
                    toastr.error("File is too big!");
                    $(input).val('');
                    return false
                }
            }
            else{
                $(input).val('');
            }
        });

    }
}
